// @flow
import * as React from 'react'
import URI from 'urijs'
import { H4, P } from 'ui/Typography'
import Link from 'ui/Link'
import Loader from 'ui/Loader'

import './NoMatch.scss'

export const NOMATCH_KEY = '_nomatch'

type State = {
  isReloading: boolean,
}

export default class NoMatch extends React.Component<{}, State> {
  constructor() {
    super()
    this.state = { isReloading: true }
  }

  componentDidMount = () => {
    const uri = new URI()
    if (!uri.hasQuery(NOMATCH_KEY)) {
      uri.addQuery(NOMATCH_KEY)
      window.location.replace(uri.toString())
    } else {
      this.setState({ isReloading: false })
    }
  }

  render = () => {
    if (this.state.isReloading) return <Loader />

    return (
      <div className="NoMatch">
        <H4>Sorry, We could not find that page!</H4>
        <P>
          {goBack()} or {goHome()}
        </P>
      </div>
    )
  }
}

function goBack() {
  return <Link onClick={() => window.history.back()}>Go back</Link>
}

function goHome() {
  return (
    <Link href="/" target="_self">
      Go home
    </Link>
  )
}
